import React, { useEffect, useState, useContext } from "react";
import EmployerProfileHeaderOfficial from "./employer_profile_header";
import { useSelector, useDispatch } from "react-redux";
//import language context
import { LanguageContext } from "../../global/languageContext";
// Caution: before you start going through, I used icons as pure SVG format thats why the code is a bit bulky, always close SVG bracket to maintain code readability.
import { getEmployerProfile } from "../../../Redux/ActionCreator";
import LoaderModal from "../../../components/LoaderModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { baseURL } from "../../../Redux/baseURL";
import { baseURL, baseURL1 } from "../../../Redux/baseURL";

import {
  googleSuccess,
  clearStoredValue,
  clearPS,
  login_success,
} from "../../../Redux/ActionCreator";
import Edit_modal from "./Edit_modal";
import EmployerContext from "./employer_contex";

function EmployerProfile() {
  const navigate = useNavigate();
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const userPics = useSelector((prev) => prev.userInfo);
  const employer = useSelector(e => e.employer);
	const [ picLink, setPicsLink ] = useState('');
  
  const profile = useSelector(prev => prev.profile);
	const params = new URLSearchParams(window.location.search).get('token');
	const profile_stat = new URLSearchParams(window.location.search).get('profile_status');
	const acctType = new URLSearchParams(window.location.search).get('AcctType');
	const myCvs = useSelector((prev) => prev.saved_cv);
	// initialize useSelector and useDispatch
	console.log('params', params);
	console.log('profile status', profile_stat);
	console.log('Accct Type', acctType);


	// called an authenticate function to verify user that logged in with linkedin and google;
	useEffect(() => {

		// dispatch(clearStoredValue());
		// dispatch(clearPS());
		
		// if (my_name !== null) {
		// 	setName(my_name.name);
		// }
		const token = localStorage.getItem('token');
		if (token === null) {
			localStorage.setItem('token', params);
			dispatch(googleSuccess({profile_status: profile_stat, AcctType: acctType}));
			dispatch(login_success({profile_status: profile_stat, AcctType: acctType}));
		}
	}, []);


  const EmployerProfile = useSelector((prev) => prev.employer);
  const body = EmployerProfile.message;
  console.log("Employer body", body);
  const dispatch = useDispatch();

  //   BigSam

  useEffect(() => {
    console.log("Called!!");
    if (body === null) {
      dispatch(getEmployerProfile());
    }
  }, []);

  function HandleUpdate() {
    navigate("/user/employer/form/update");
  }

  return (
    <>
      {EmployerProfile.isloading === true ? (
        <LoaderModal />
      ) : (
        <>
          {EmployerProfile.message !== null ? (
            <div className="px-[2.5%] w-full h-full overflow-y-hidden mx-auto ">
              <h1 className=" font-medium text-xl tablet:text-4xl text-[#626060]">
                My Profile
              </h1>
              <div className="my-4 w-full h-full bg-[#FDFCFD]  rounded-2xl flex flex-col items-center">
                <EmployerProfileHeaderOfficial HandleUpdate={HandleUpdate} />

                {/* bottom white content of page  */}
                <div className="w-[100%] tablet:w-[80%] flex flex-col items-center my-9 gap-9 mx-auto relative">
                  {/* Divider line  */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* Edit modal  */}
                  {/* <Edit_modal
                    // open={openModal}
                    // onClose={() => setOpenModal(false)}

                    // aboutData={aboutData}
                    // onSave={saveAboutData}
                    /> */}

                  {/* About page  */}
                  <div className="flex flex-col tablet:flex-row gap-10 w-full">
                    <div className="bg-white rounded-xl border border-[#D2D4F8] p-5 w-full tablet:w-[70%] flex justify-between">
                      {/* content  */}
                      <div className="w-[90%]">
                        <h1 className="text-[#5843BD] font-semibold text-base">
                          About
                        </h1>
                        <p className=" text-sm font-normal text-[#666666]">
                          {body?.about}
                        </p>
                      </div>

                      {/* edit icon  */}
                      <div onClick={HandleUpdate}>
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                            fill="#FF6633"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="flex flex-col gap-4">
                      {/* info  */}
                      <div className="bg-white rounded-xl border border-[#D2D4F8] p-5">
                        <h1 className="text-[#5843BD] font-semibold text-base">
                          Info
                        </h1>
                        <p className=" text-sm font-normal text-[#666666]">
                          {body.info}
                        </p>
                      </div>
                      {/* location  */}
                      <div className="bg-white rounded-xl border border-[#D2D4F8] p-5">
                        <h1 className="text-[#5843BD] font-semibold text-base">
                          Location
                        </h1>
                        <p className=" text-sm font-normal text-[#666666]">
                          {`${body.location?.city}, ${body.location?.state}, ${body.location?.country}.`}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Divider line */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* EIN Employees  */}
                  <div className=" tablet:flex justify-between w-full">
                    <div className="w-full tablet:w-[45%] flex justify-between bg-[#F2F2F2] p-4 rounded-xl">
                      {/* content 1 */}
                      <div className="w-[80%]">
                        <h1 className="text-[#5843BD] font-semibold text-base">
                          {" "}
                          (EIN)
                        </h1>
                        <p className=" text-sm font-normal text-[#666666]">
                          {body?.Employer_Identification_Number}
                        </p>
                      </div>

                      {/* edit icon  */}
                      <div onClick={HandleUpdate}>
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                            fill="#FF6633"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* content 2 */}
                    <div className="w-full mt-6 tablet:mt-0 tablet:w-[45%] flex justify-between bg-[#F2F2F2] p-4 rounded-xl">
                      <div className="w-[80%]">
                        <h1 className="text-[#5843BD] font-semibold text-base">
                          Employees
                        </h1>
                        <p className=" text-sm font-normal text-[#666666]">
                          {body?.no_of_employees}
                        </p>
                      </div>

                      {/* edit icon  */}
                      <div onClick={HandleUpdate}>
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                            fill="#FF6633"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Divider line */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* Phone number  */}
                  <div className=" w-full flex justify-between ">
                    <div className="w-[80%]">
                      <h1 className="text-[#5843BD] font-semibold text-base">
                        Phone Number
                      </h1>
                      <p className=" text-2xl font-semibold text-black pt-2">
                        {body?.phone_number}
                      </p>
                    </div>

                    {/* edit icon  */}
                    <div onClick={HandleUpdate}>
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                          fill="#FF6633"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Divider line */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* Email Address  */}
                  <div className=" w-full">
                    <h1 className="text-[#5843BD] font-semibold text-base">
                      Email Address
                    </h1>

                    <div className=" tablet:flex justify-between w-full">
                      <div className="w-full  tablet:w-[45%]">
                        {/* content 1 */}
                        <p
                          className="bg-[#F2F2F2] border-none rounded-md w-full h-14 flex items-center px-4"
                          //   placeholder="officialbiodun@gmail.com"
                        >
                          {body.email}
                        </p>
                      </div>

                      {/* content 2 */}
                      <div className=" mt-1 tablet:mt-0 w-full tablet:w-[45%]">
                        <div className="bg-transparent border-none rounded-md w-full h-14">
                          <p className=" font-medium text-sm text-[#FF6633]">
                            Only an admin can change your email address, contact
                            admin{" "}
                            <span className="text-[#1400FF] underline">
                              here.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Divider line */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* Opening Hours  */}
                  <div className=" w-full flex justify-between ">
                    <div className="w-[80%]">
                      <h1 className="text-[#5843BD] font-semibold text-base">
                        Opening Hours
                      </h1>
                      <div className="flex items-center gap-6 pt-4">
                        <p className=" font-normal text-base text-black">
                          Opens:{" "}
                          <span className="font-semibold text-base text-[#FF6633]">
                            {body?.hours.opening}
                          </span>
                        </p>
                        <p className=" font-normal text-base text-black">
                          Closes:{" "}
                          <span className="font-semibold text-base text-[#FF6633]">
                            {body?.hours.closing}
                          </span>
                        </p>
                      </div>
                    </div>

                    {/* edit icon  */}
                    <div onClick={HandleUpdate}>
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                          fill="#FF6633"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Divider line */}
                  <hr className=" bg-[#E9E9FB] w-full" />

                  {/* Pay Structure  */}
                  <div className=" w-full flex justify-between ">
                    <div className="w-[80%]">
                      <h1 className="text-[#5843BD] font-semibold text-base">
                        Pay Structure
                      </h1>
                      <div className="flex items-center gap-6 pt-4">
                        {/* checkboxes  */}
                        <div className=" flex gap-3 items-center">
                          <input
                            type="checkbox"
                            className=" bg-white border border-[#5843BD] checked:bg-[#5843BD] focus:bg-transparent active:bg-[#5843BD] focus:outline-none outline-none checked:outline-none focus:ring-1 focus:ring-[#5843BD] focus:ring-opacity-50 appearance-none transition duration-150 ease-in-out fill-current w-[27px] h-[27px] rounded-md"
                          />
                          <label
                            htmlFor="checkbox"
                            className=" font-medium text-base"
                          >
                            {body.pay_structure}
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* edit icon  */}
                    <div onClick={HandleUpdate}>
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                          fill="#FF6633"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <LoaderModal text="Fetching profile" />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default EmployerProfile;
